import { Text, Tooltip } from '@radix-ui/themes';
import type { ReactNode } from 'react';

export const HubertTooltip = ({ tooltip, children }: { tooltip: string; children: ReactNode }) => (
  <Tooltip content={<Text size="3">{tooltip}</Text>}>{children}</Tooltip>
);
